import { render, staticRenderFns } from "./assist-manage-fixed.vue?vue&type=template&id=926cbf12&scoped=true"
import script from "./assist-manage-fixed.vue?vue&type=script&lang=ts"
export * from "./assist-manage-fixed.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "926cbf12",
  null
  
)

export default component.exports